// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"style_subtitle__2T52Q","empty":"style_empty__3MlQY","option":"style_option___-zwU","fields":"style_fields__3J4C_","dark":"style_dark__aDXam"};